var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"smooth-scroll",rawName:"v-smooth-scroll"}],staticClass:"scrollBack",attrs:{"href":"#app"}},[_c('img',{attrs:{"src":require("../assets/scrollUp_Icon.svg"),"alt":"Scroll Back"}})])}
var staticRenderFns = []

export { render, staticRenderFns }